/*
 * $Id:: inputsMaxChars.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

export default {
    firstName: 256,
    lastName: 256, //surname
    legalName: 256,
    organisationName: 256,
    username: 50,
    email: 50,
    password: 30,
    vatCode: 256,
    legalForm: 500,
    vatNumber: 256,
    streetName: 256,
    streetNumber: 10,
    city: 256,
    postalCode: 10,
    corrName: 256,
    corrTelephone: 50,
    corrEmail: 50,
    telephone: 50,
    fax: 50,
    website: 256,
    //representative extra fields
    economicNature: 500,
    employerName: 256,
};
